/*
 * Product card colour swatches: hovering a swatch previews that colour's
 * image in the card; leaving the card restores the original. Event
 * delegation on document, so it covers cards added later (collection
 * "Load more", filter re-renders, homepage tab panels). Guarded so it
 * installs once even if several sections load this file.
 */
(() => {
  if (window.__productCardSwatches) return;
  window.__productCardSwatches = true;

  const primaryImage = (card) => card.querySelector('.product-card__image--primary');

  const preview = (card, swatch) => {
    const img = primaryImage(card);
    if (!img) return;
    if (img.dataset.origSrc === undefined) {
      img.dataset.origSrc = img.getAttribute('src') || '';
      img.dataset.origSrcset = img.getAttribute('srcset') || '';
    }
    img.setAttribute('srcset', swatch.dataset.swatchSrcset || '');
    img.setAttribute('src', swatch.dataset.swatchSrc);
    card.classList.add('is-swatch-preview');
    card.querySelectorAll('.product-card__swatch.is-active').forEach((el) => el.classList.remove('is-active'));
    swatch.classList.add('is-active');
  };

  const restore = (card) => {
    const img = primaryImage(card);
    if (img && img.dataset.origSrc !== undefined) {
      if (img.dataset.origSrcset) img.setAttribute('srcset', img.dataset.origSrcset);
      else img.removeAttribute('srcset');
      img.setAttribute('src', img.dataset.origSrc);
    }
    card.classList.remove('is-swatch-preview');
    card.querySelectorAll('.product-card__swatch.is-active').forEach((el) => el.classList.remove('is-active'));
  };

  document.addEventListener('pointerover', (event) => {
    if (event.pointerType && event.pointerType !== 'mouse') return;
    const swatch = event.target.closest('.product-card__swatch[data-swatch-src]');
    if (!swatch) return;
    const card = swatch.closest('.product-card');
    if (card) preview(card, swatch);
  });

  document.addEventListener('pointerout', (event) => {
    const card = event.target.closest('.product-card.is-swatch-preview');
    if (!card || card.contains(event.relatedTarget)) return;
    restore(card);
  });
})();
